var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-layout"},[_c('AppSidebar'),_c('div',{staticClass:"app-main"},[_c('AppHeader',{attrs:{"tabs":_vm.tabs},on:{"activate-tab":_vm.activateTab,"close-tab":_vm.closeTab,"close-other-tabs":_vm.closeOtherTabs}}),_c('main',{staticClass:"app-content"},[_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }